




import { Vue, Component } from 'vue-property-decorator';
import CalibrationPage from './calibration.vue';

@Component({
    components: {
        CalibrationPage
    }
})
export default class KnowledgeManagePage extends Vue {
    /**
     * 获取RG ID
     */
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
